<template>
  <v-container fluid style="padding-top: 0;">
    <v-row>
      <v-col cols="12" sm="12" md="6" class="py-0 search-space">
        <v-text-field
          filled
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Buscar"
          dense
          @keyup.enter="HandlerGetProducts(1)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="12" md="6" class="py-0 search-space">
        <v-combobox
          v-model="selectedBrands"
          :items="brands"
          label="Marcas"
          dense
          filled
          multiple
          small-chips
          background-color="transparent"
          clearable
        ></v-combobox>
        <!-- <v-autocomplete
          filled
          v-model="brand_id"
          :items="keys"
          item-text="name"
          :item-value="(item) => item"
          dense
          prepend-inner-icon="mdi-magnify"
          label="Marcas"
        ></v-autocomplete> -->
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" md="12" class="pt-0">
        <div v-if="searchProducts">
          <v-row v-if="itemsPublications.length > 0">
            <v-col
              v-for="(item, index) in itemsPublications"
              :key="index"
              cols="12"
              sm="6"
              md="3"
              lg="3"
            >
              <v-card
                class="shadow-small round"
                style="width: 100%;"
                @click="details(item)"
              >
                <v-card-text>
                  <img
                    v-if="item.pictures == null"
                    :aspect-ratio="4 / 3"
                    height="218"
                    width="100%"
                    contain
                    src="../../../assets/no_image.jpg"
                    alt="noImage"
                  />
                  <v-img
                    v-else
                    height="218"
                    :lazy-src="item.pictures[0]"
                    :src="item.pictures[0]"
                    class="grey lighten-2"
                    style="margin-bottom: 18px"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <div class="row-description mt-3">
                    <div>
                      <div
                        class="text-uppercase font-weight-bold title-product"
                      >
                        {{ item.title }}
                      </div>
                      <v-card-subtitle class="px-0 pt-1 pb-0 price-text">
                        PVP: {{ item.pvp_with_discount | number_format }}
                      </v-card-subtitle>
                    </div>
                    <v-btn class="custom-btn">VER DETALLE</v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else justify="center">
            <v-col cols="12" md="9" class="d-flex justify-center">
              <p class="text-center py-10 font-weight-medium">
                No hay resultados para su busqueda
              </p>
            </v-col>
          </v-row>
          <v-row justify="center" class="mb-0">
            <v-col v-if="paginationData.lastPage > 1" cols="12" md="4">
              <div class="text-center">
                <v-pagination
                  color="#343EC4"
                  v-model="page"
                  :length="paginationData.lastPage"
                  circle
                ></v-pagination>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-row v-else>
          <v-col class="mx-auto">
            <looping-rhombuses-spinner
              class="mx-auto"
              :animation-duration="2500"
              :rhombus-size="80"
              color="#402DCE"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { LoopingRhombusesSpinner } from "epic-spinners";
export default {
  components: {
    LoopingRhombusesSpinner,
  },
  data() {
    return {
      loading: false,
      searchProducts: false,
      search: "",
      sortDesc: false,
      page: 1,
      itemsPerPage: 8,
      sortBy: "",
      items: [],
      keys: [],
      brand_id: "",
      selectedBrands: [],
    };
  },

  computed: {
    itemsPublications() {
      return this.$store.getters["product/ITEMS_PRODUCTS"] || [];
    },
    itemsDiscount() {
      return this.$store.getters["auth/DISCOUNT_CLIENT"];
    },
    paginationData() {
      return this.$store.getters["product/GET_PAGINATION"];
    },
    brands() {
      return Object.keys(this.$store.getters["shoppingCart/GET_BRANDS"]);
    },
  },

  created() {
    this.HandlerGetProducts();
    this.HandlerGetBrands();
  },

  watch: {
    page(page) {
      this.HandlerGetProducts(page);
    },
    selectedBrands() {
      this.HandlerGetProducts();
    },
  },

  filters: {
    number_format(
      value,
      decimals = 2,
      separatorThousands = ".",
      separatorDecimals = ","
    ) {
      let number = parseFloat(value);
      if (!isFinite(number) || (!number && number !== 0)) return "";
      let [integer, decimal] = Math.abs(number)
        .toFixed(decimals)
        .split(".");
      let length = integer.length;
      while (length > 3) {
        length -= 3;
        integer =
          integer.slice(0, length) + separatorThousands + integer.slice(length);
      }
      let sign = number < 0 ? "-" : "";
      return `${sign}${integer}${separatorDecimals}${decimal}`;
    },
  },

  methods: {
    pvc(item) {
      let pvc_total_product = item - (item * this.itemsDiscount) / 100;

      return pvc_total_product;
    },

    async HandlerGetProducts(page = 1) {
      try {
        this.searchProducts = false;
        const request = {
          page: page,
          per_page: this.itemsPerPage,
          paginate: true,
          brands: this.selectedBrands.map(
            (brand) => this.$store.getters["shoppingCart/GET_BRANDS"][brand]
          ),
          search: this.search,
        };
        this.page = page;
        await this.$store.dispatch("product/GET_CATALOG_PRODUCTS", request);
        this.searchProducts = true;
      } catch (error) {
        this.searchProducts = true;
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      } finally {
        this.searchProducts = true;
      }
    },
    async HandlerGetBrands() {
      try {
        await this.$store.dispatch("shoppingCart/GET_BRANDS");
      } catch (error) {
        console.log(error);
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      }
    },

    async getBrands() {
      const response = await this.$store.dispatch("product/BRANDS");
      this.keys = response;
    },

    details(product) {
      this.$store.commit("product/SET_ONE_PRODUCT", product);
      this.$router.push({
        name: "product_details",
        query: { id: product.id },
      });
    },
  },
};
</script>

<style>
.shadow-small {
  box-shadow: 0 2px 4px rgba(27, 31, 35, 0.15) !important;
}
.round {
  border-radius: 20px !important;
  height: 100%;
}
.title-product {
  font-size: 18px;
  font-weight: 600 !important;
  color: black;
  margin-bottom: 6px !important;
}
.price-text {
  font-size: 14px;
  font-weight: 500;
  color: black !important;
}
.custom-btn {
  padding: 0px 10px !important;
  height: 32px !important;
  background-color: #343ec4 !important;
  color: white !important;
  font-size: 12px !important;
}
.row-description {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.search-space {
  margin-bottom: -14px;
}
</style>
